import {
  ICommonWPClass,
  IExpressAvailability,
  IScratchpayRenewalPending,
  IUpdatePaymentMethod,
} from "../../services/get-alerts/get-alerts.interface";

export const actionTypes = {
  SET_IS_DUPLICATE_ACCOUNT: "SET_IS_DUPLICATE_ACCOUNT",
  SET_SHOULD_SHOW_WELLNESS_UPSELL: "SET_SHOULD_SHOW_WELLNESS_UPSELL",
  SET_SHOULD_SHOW_PREQUALIFICATION: "SET_SHOULD_SHOW_PREQUALIFICATION",
  SET_SHOW_URGENT_VISIT_UPSELL: "SET_SHOW_URGENT_VISIT_UPSELL",
  SET_IS_EXPRESS_ELIGIBLE: "SET_IS_EXPRESS_ELIGIBLE",
  SET_UPDATE_PAYMENT_METHOD: "SET_UPDATE_PAYMENT_METHOD",
  SET_ALERTS_DATA_UPDATED: "SET_ALERTS_DATA_UPDATED",
  SET_RECENTLY_ENDED_WP_DATA: "SET_RECENTLY_ENDED_WP_DATA",
  SET_FAILED_RENEWAL_AFTER_GRACE: "SET_FAILED_RENEWAL_AFTER_GRACE",
  SET_FAILED_RENEWAL_WITH_GRACE: "SET_FAILED_RENEWAL_WITH_GRACE",
  SET_RECENT_RENEWED_WP_DATA: "SET_RECENT_RENEWED_WP_DATA",
  SET_ENDS_SOON_WP_DATA: "SET_ENDS_SOON_WP_DATA",
  SET_FAILED_RENEWAL_WP_DATA: "SET_FAILED_RENEWAL_WP_DATA",
  SET_REFERRAL_UPSELL: "SET_REFERRAL_UPSELL",
  SET_SCRATCHPAY_RENEWAL_PENDING: "SET_SCRATCHPAY_RENEWAL_PENDING",
} as const;

// Non wellness alerts

const setIsDuplicateAccount = (payload: boolean) => ({
  type: actionTypes.SET_IS_DUPLICATE_ACCOUNT,
  payload,
});

const setShouldShowWellnessUpsell = (payload: boolean) => ({
  type: actionTypes.SET_SHOULD_SHOW_WELLNESS_UPSELL,
  payload,
});

const setShouldShowPrequalification = (payload: boolean) => ({
  type: actionTypes.SET_SHOULD_SHOW_PREQUALIFICATION,
  payload,
});


const setShowUrgentVisitUpsell = (payload: boolean) => ({
  type: actionTypes.SET_SHOW_URGENT_VISIT_UPSELL,
  payload,
});

const setIsExpressEligible = (payload: IExpressAvailability[]) => ({
  type: actionTypes.SET_IS_EXPRESS_ELIGIBLE,
  payload,
});

const setUpdatePaymentMethod = (payload: IUpdatePaymentMethod[]) => ({
  type: actionTypes.SET_UPDATE_PAYMENT_METHOD,
  payload,
});

// Non wellness alerts

const setRecentlyEndedWPData = (payload: ICommonWPClass[]) => ({
  type: actionTypes.SET_RECENTLY_ENDED_WP_DATA,
  payload,
});

const setFailedRenewalAfterGrace = (payload: ICommonWPClass[]) => ({
  type: actionTypes.SET_FAILED_RENEWAL_AFTER_GRACE,
  payload,
});

const setFailedRenewalWithGrace = (payload: ICommonWPClass[]) => ({
  type: actionTypes.SET_FAILED_RENEWAL_WITH_GRACE,
  payload,
});

const setRecentRenewedWPData = (payload: ICommonWPClass[]) => ({
  type: actionTypes.SET_RECENT_RENEWED_WP_DATA,
  payload,
});

const setEndsSoonWPData = (payload: ICommonWPClass[]) => ({
  type: actionTypes.SET_ENDS_SOON_WP_DATA,
  payload,
});

const setFailedRenewalWPData = (payload: ICommonWPClass[]) => ({
  type: actionTypes.SET_FAILED_RENEWAL_WP_DATA,
  payload,
});

const setShowReferralUpsell = (payload: boolean) => ({
  type: actionTypes.SET_REFERRAL_UPSELL,
  payload,
});

const setScratchpayRenewalPending = (payload: IScratchpayRenewalPending[]) => ({
  type: actionTypes.SET_SCRATCHPAY_RENEWAL_PENDING,
  payload,
});

// Store update status state

const setAlertsDataUpdated = (payload: boolean) => ({
  type: actionTypes.SET_ALERTS_DATA_UPDATED,
  payload,
});


export default {
  setIsDuplicateAccount,
  setShouldShowWellnessUpsell,
  setShouldShowPrequalification,
  setShowUrgentVisitUpsell,
  setIsExpressEligible,
  setUpdatePaymentMethod,
  setAlertsDataUpdated,
  setRecentlyEndedWPData,
  setFailedRenewalAfterGrace,
  setFailedRenewalWithGrace,
  setRecentRenewedWPData,
  setEndsSoonWPData,
  setFailedRenewalWPData,
  setShowReferralUpsell,
  setScratchpayRenewalPending,
};
